import React from 'react';
import styles from './index.module.scss';
const SIZES_NORMALIZER = {
    S: 'x32',
    M: 'x44',
    L: 'x56'
};
class Spinner extends React.Component {
    render() {
        const { color = 'white', size = 'L' } = this.props;
        return (React.createElement("div", { className: `${styles.ring} ${styles[color]} ${styles[SIZES_NORMALIZER[size]]}` },
            React.createElement("div", null),
            React.createElement("div", null),
            React.createElement("div", null),
            React.createElement("div", null)));
    }
}
export default Spinner;
